var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHarvest = function SvgHarvest(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 10v10h16v-10h-16zm0-2h16c1 0 2 1 2 2v10c0 1-1 2-2 2h-16c-1 0-2-1-2-2v-10c0-1 1-2 2-2zm3 6c-.265 0-.52.105-.707.293-.188.188-.293.442-.293.707 0 .265.105.52.293.707.188.188.442.293.707.293h10c.265 0 .52-.105.707-.293.188-.188.293-.442.293-.707 0-.265-.105-.52-.293-.707-.188-.188-.442-.293-.707-.293h-10z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.047 8h-2.008c.17-2.138.898-4.022 2.18-5.625.094-.117.213-.212.348-.277.135-.065.283-.099.433-.099.15 0 .298.034.433.099s.254.16.348.277c1.282 1.603 2.009 3.487 2.179 5.625h-2.008c-.113-1.178-.43-2.243-.953-3.203-.523.96-.84 2.025-.953 3.203h.001zm.961 8h-.017.017zm-6.008-11.874c1.725.444 3 2.01 3 3.874h-2c0-.53-.211-1.039-.586-1.414s-.884-.586-1.414-.586c-.53 0-1.039.211-1.414.586s-.586.884-.586 1.414h-2c0-.887.295-1.749.838-2.45.543-.701 1.304-1.202 2.162-1.424v-.126c0-.265.105-.52.293-.707.188-.188.442-.293.707-.293.265 0 .52.105.707.293.188.188.293.442.293.707v.126z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHarvest, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/harvest.100878ac.svg";
export { ForwardRef as ReactComponent };